export { default as useFileAttachments } from './useFileAttachments';
